import { Autocomplete, Checkbox, Chip, createFilterOptions, InputAdornment, TextField, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FunctionComponent, useEffect, useLayoutEffect, useState } from "react";
import { UpdateMenuFlag } from "../../actions";
import { OptionsData } from "../../models/grid.model";
import ButtonComponent from "./button/button.component";
import ButtonModel from "./button/button.model";
import Badge from "@mui/material/Badge";
import { FilterDarkIcon, FilterPrimaryIcon, BurgerMenuIcon, GridSearchIcon, SearchButtonClearedIcon } from "../../icon";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { OrganizationModel } from "../../models/organization.model";
import { findIndex } from "lodash";

interface IProps {
    HeaderText?: string;
    Reload?: () => void;
    Actions?: ButtonModel[];
    HandleFilter?: (e) => void;
    ShowFilterIcon?: boolean;
    Count?: number;
    ErrPage?: boolean;
    HideBurgerMenu?: boolean;
    onSearch?: (e) => void;
    ShowMultiActionButtons?: boolean;
    MultiActionButtons?: OptionsData[]
    GridTitle?: string;
    PlaceHolder?: string;
    IsFilterApplied?: any
    HideSearch?: boolean;
    searchValue?: string;
    showAutoComplete?: boolean;
    autoCompleteOptions?: OrganizationModel[];
    onChangeAutoComplete?: (ids: string[]) => void;
    autoCompleteValue?: string[];
    isReport?: boolean;
}

const PageHeaderComponent: FunctionComponent<IProps> = (props: IProps) => {
    const dispatch = useDispatch()
    const Autofilter = createFilterOptions();

    const HeaderTitle: string = useSelector(selector.headerTitle)
    const HeaderCount: number = useSelector(selector.headerCount)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [showSearch, setShowSearch] = useState(false);
    const [hideSearch, setHideSearch] = useState(false);

    const [searchText, setSearchText] = useState(props.searchValue || '')

    const handleClear = () => {
        setSearchText("")
        if (props.onSearch) {
            const event = { target: { value: "" } }
            props.onSearch(event)
        }
    }

    const handleChange = (event) => {
        const value = event.target.value
        setSearchText(value)
        if (props.onSearch) {
            props.onSearch(event)
        }
    }

    useEffect(() => {
        setSearchText(props.searchValue || "")
    }, [props.searchValue])

    useLayoutEffect(() => {
        setShowSearch(!props.ShowMultiActionButtons && !(IsMobileDevice && props?.showAutoComplete))
    }, [props.ShowMultiActionButtons, props?.showAutoComplete])

    useEffect(() => {
        if (props.searchValue) {
            setShowSearch(true)
        }
    })

    const ToggleSearch = () => {
        setShowSearch(!showSearch);
    }

    useEffect(() => {
        if (!!props.HideSearch) {
            setHideSearch(true)
        }
        else {
            setHideSearch(false)
        }
    }, [props.HideSearch])

    return <div className={`d-flex w-fill flex-direction bg-color-primary-background ${(props.ErrPage && IsMobileDevice) && 'paper-background'} my-auto ${IsMobileDevice ? 'px-1' : 'px-2'}`}>
        {IsMobileDevice && <div className="d-flex justify-between">
            <div className="d-flex">
                {!props.HideBurgerMenu &&
                    <span className={`py-1 pr-1 ${props.ErrPage && 'pl-2'} my-auto`} style={{ zIndex: 100 }}>
                        <BurgerMenuIcon onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true); }} />
                    </span>}
                <div className={"d-flex my-auto"}>
                    <span className={`color-header-title-font w-space ${!props.isReport ? "h3-semibold" : "h4-semibold"}`}>
                        {`${props.HeaderText || HeaderTitle || ""}`}
                        <span className={`color-header-count-font ${!props.isReport ? "h3-semibold" : "h4-semibold"}`}>
                            {
                                props.Count !== undefined ? ` | ${props.Count} Records` : HeaderCount !== undefined ? ` | ${HeaderCount} Records` : ""
                            }
                        </span>
                    </span>

                </div>

            </div>
            {(!!props.Actions || props.ShowFilterIcon) &&
                props.ShowFilterIcon && <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={props.HandleFilter} tabIndex={5} className={`${IsMobileDevice ? "pr-2" : " "}`}>
                    <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={props.IsFilterApplied} >
                        {props.IsFilterApplied ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                    </Badge>
                </IconButton>}
        </div>}
        < div className="w-fill d-flex justify-between">
            <div className="d-flex justify-between align-center my-auto">
                {!IsMobileDevice &&
                    <div className="d-flex">
                        {!!props.GridTitle && <span className="d-flex color-header-title-font h4-semibold my-auto mr-1 w-space">{props.GridTitle}</span>}
                        {props.showAutoComplete && <div className="mr-2">
                            <Autocomplete
                                multiple
                                size="small"
                                disableCloseOnSelect={true}
                                className={`my-1 pr-2  ${IsMobileDevice ? "w-v-30" : "w-v-15 "}`}
                                options={props.autoCompleteOptions}
                                getOptionLabel={(option: any) => option.Name ? option.Name : ""}
                                onChange={(e: any, value: any[]) => {
                                    let val = value.map(x => findIndex(x.ID))
                                    if (val.find(x => x === -1)) {
                                        if (props.autoCompleteOptions.length === props.autoCompleteValue.length) {
                                            props.onChangeAutoComplete([]);
                                        }
                                        else {
                                            props.onChangeAutoComplete(props.autoCompleteOptions.map((item) => item.ID));
                                        }
                                    }
                                    else {
                                        props.onChangeAutoComplete(value.map((item: any) => item.ID));
                                    }
                                }}
                                value={props.autoCompleteOptions?.filter((x) => props.autoCompleteValue?.includes(x.ID)) || []
                                }
                                filterOptions={(options: any[], params: any) => {
                                    if (props.autoCompleteOptions.length > 0) {
                                        const filtered = Autofilter(options, params);
                                        return [{ Name: "Select all", value: -1 }, ...filtered];
                                    } else if (props.autoCompleteOptions.length === 0) {
                                        const filtered = Autofilter(options, params);
                                        return [...filtered];
                                    }
                                    else { return options; }
                                }}
                                renderOption={(defaultprops, option: any, { selected }) => {
                                    const selectAll = props.autoCompleteValue.length > 0 && option.value === -1
                                        ? { checked: (props.autoCompleteOptions.length === props.autoCompleteValue.length) }
                                        : {};
                                    return (
                                        <li {...defaultprops} className="p-1 d-flex justify-flex-start">
                                            <Checkbox
                                                sx={{
                                                    padding: '5px',
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: 16,
                                                    },
                                                }}
                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                checked={selected}
                                                {...selectAll}
                                            />
                                            <span className="h4-regular ml-1"> {option?.Name} </span>
                                        </li>
                                    )
                                }}
                                classes={{
                                    input: "color-text-field-font h6-regular",
                                    paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow'
                                }}
                                tabIndex={16}
                                renderTags={(value, getTagProps) =>
                                    <div className="d-flex o-x-auto align-center">
                                        {
                                            value.map((option, index) => (
                                                <Chip
                                                    classes={{
                                                        colorPrimary: "custom-color-chip-2",
                                                        avatarColorPrimary: "custom-chip-avatar",
                                                    }}
                                                    color="primary"
                                                    label={option.Name}
                                                    {...getTagProps({ index })}
                                                    style={{
                                                        marginRight: '3px'
                                                    }}
                                                />
                                            ))
                                        }
                                    </div>
                                }
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        name="Select Organizations *"
                                        label="Select Organizations *"
                                        placeholder={props.autoCompleteValue.length === 0 ? "Select Organizations *" : ""}
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { overflowX: 'hidden', textOverflow: 'ellipsis', flexWrap: 'nowrap', paddingRight: '30px' }
                                        }}
                                        style={{ flexGrow: 1, minWidth: 0, maxWidth: '100%' }}
                                    />
                                }
                            />
                        </div>
                        }
                    </div>}
                <div className="d-flex">
                    {props.ShowMultiActionButtons && !!props.MultiActionButtons && props.MultiActionButtons.map((btn: OptionsData, index: number) => !btn.Hide &&
                        <button className={`pr-2 pl-1 grid-btn grid-btn-${btn.Variant} ${btn.ClassName}`} key={`${btn.Name}-${index}`} onClick={btn.OnClick}>
                            {!!btn.Icon && <btn.Icon className="w-3" />}
                            {btn.Name}
                        </button>)}
                </div>
                {!hideSearch && (showSearch ?
                    <TextField
                        inputProps={{
                            tabIndex: 4,
                            "data-arrow-index": 200,
                        }}
                        fullWidth
                        placeholder={props.PlaceHolder}
                        value={searchText}
                        onChange={handleChange}
                        variant="standard"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <GridSearchIcon style={{ paddingBottom: "5px" }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                searchText && (
                                    <InputAdornment position="end">
                                        <button
                                            className="d-flex c-pointer"
                                            onClick={handleClear}
                                        >
                                            <SearchButtonClearedIcon />
                                        </button>
                                    </InputAdornment>
                                )
                            ),
                            disableUnderline: true
                        }}
                        size="small"
                        className="my-auto"
                        sx={{
                            '& .MuiInputBase-root': {
                                borderBottom: '0.5px solid rgb(130, 137, 147)',
                                '&:hover': {
                                    borderBottom: '0.5px solid #e2e8f0'
                                },
                                '&.Mui-focused': {
                                    borderBottom: '0.5px solid rgb(10, 17, 25)'
                                }
                            },
                            '& .MuiInputBase-input': {
                                paddingLeft: '0px',
                                '&::placeholder': {
                                    color: '#a0aec0',
                                    opacity: 1
                                }
                            }
                        }}
                    /> :
                    <GridSearchIcon onClick={ToggleSearch} className="c-pointer" />)}
            </div>
            <div className={`${props.showAutoComplete ? "mt-2" : ""}`}>
                {(!!props.Actions || props.ShowFilterIcon) && <div className="d-flex justify-between">
                    {!!props.Actions && props.Actions.map((x, i) => <ButtonComponent buttonProps={{ tabIndex: 5 + i, "data-up-arrow-index": 4 }} key={i} {...x} ClassName='w-space ml-1 mr-1' />)}
                    {!IsMobileDevice && props.ShowFilterIcon && <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={props.HandleFilter} tabIndex={5}>
                        <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={props.IsFilterApplied} >
                            {props.IsFilterApplied ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                        </Badge>
                    </IconButton>}
                </div>}
            </div>
        </div>
    </div >
}

export default PageHeaderComponent;
